import ItemModel from "../item-model"
import {ListItemCalculatedValues} from "../@type"
import {AggregateFunctionType} from "../../../data-structures/aggregators/types"

function convertCalculatedFormat(calculatedValues?: ListItemCalculatedValues) {
    const data =  {
        own         : calculatedValues?.own,
        children    : {
            value: calculatedValues?.children
        },
        total       : {
            value: calculatedValues?.total
        },

        hasOwnValue: !!calculatedValues?.own,
        hasChildren: !!calculatedValues?.children
    }

    return {
        [AggregateFunctionType.SUM]                     : data,
        [AggregateFunctionType.MIN]                     : data,
        [AggregateFunctionType.MAX]                     : data,
        [AggregateFunctionType.MEDIAN]                  : data,
        [AggregateFunctionType.AVERAGE]                 : data,
        [AggregateFunctionType.CHECKED_TOTAL]           : data,
        [AggregateFunctionType.SUMMARY_COUNT]           : data,
        [AggregateFunctionType.TOTAL_SPENT_ESTIMATE]    : data,
        [AggregateFunctionType.DATE_MIN]                : data,
        [AggregateFunctionType.DATE_MAX]                : data,
        [AggregateFunctionType.DATE_RANGE]              : data,
        undefined                                       : data, // if no aggregate function is selected
    }
}

// function to calculate percentage of time reported out of estimate
function getSpentEstimate(reportedTime?: number | null, estimate?: number | null) {
    if (!estimate) {
        // return undefined if estimate is not set
        return undefined
    }

    if (!reportedTime) {
        // if nothing reported, spent is 0%
        return 0
    }

    return Math.floor(100 * reportedTime/estimate)
}

// const debug = "ItemCalculatedValuesAdapter"
const debug = false

export class ItemCalculatedValuesAdapter {

    private itemModel: ItemModel

    constructor(itemModel: ItemModel) {
        this.itemModel  = itemModel
    }

    get dataByAggregateFunction() {
        return {
            calculatedEstimated         : convertCalculatedFormat(this.itemModel.estimated),
            calculatedStoryPoints       : convertCalculatedFormat(this.itemModel.calculatedStoryPoints),
            calculatedTimeReports       : convertCalculatedFormat(this.itemModel.reported),
            calculatedSpentEstimated    : convertCalculatedFormat({
                own         : getSpentEstimate(this.itemModel.reported?.own, this.itemModel.estimated?.own),
                children    : getSpentEstimate(this.itemModel.reported?.children, this.itemModel.estimated?.children),
                total       : getSpentEstimate(this.itemModel.reported?.total, this.itemModel.estimated?.total),
            }),
            calculatedLaborCost         : convertCalculatedFormat(this.itemModel.costInternal),
            calculatedServiceCost       : convertCalculatedFormat(this.itemModel.costExternal),
            calculatedExpenses          : convertCalculatedFormat(this.itemModel.calculatedExpenses),

            estimatedCostInternal       : convertCalculatedFormat(this.itemModel.estimatedCostInternal),
            estimatedCostExternal       : convertCalculatedFormat(this.itemModel.estimatedCostExternal),
        }
    }
}